import {Component, Input, OnInit, inject, DestroyRef} from '@angular/core';
import {ServiceCardService} from '../../../services/util/service-card.service';
import {SolutionsService} from '../../../services/api/solutions.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {ServiceCardInfo} from '../../../models/service/service-card-info';
import {serviceStatuses} from '../../../models/service/service-status';
import {AuthService} from '../../../services/auth/auth.service';
import {RouterSegments} from 'src/app/models/router-segments';
import {Solution} from 'src/app/models/service/solution';
import {SolutionVersion} from 'src/app/models/service/solution-version';
import {map, mergeMap} from 'rxjs/operators';
import {forkJoin} from 'rxjs';

@Component({
    selector: 'app-my-services',
    templateUrl: './my-services.component.html',
    styleUrls: ['./my-services.component.scss'],
    standalone: false
})
export class MyServicesComponent  implements OnInit {

  @Input() showTitle: boolean;
  tenant: string;
private destroyRef = inject(DestroyRef);

  servicesVersionsMap = new Map<string, SolutionVersion[]>();

  cardInfos: ServiceCardInfo[] = [];
  filteredCardInfos: ServiceCardInfo[] = [];
  filters: Set<string> = new Set();
  statusToCount: Map<string, number> = new Map();

  totalCount = 0;
  serviceStatuses = serviceStatuses;

  RouterSegments = RouterSegments;

  constructor(private serviceCardService: ServiceCardService,
              private solutionsService: SolutionsService,
              private authService: AuthService) {
    
  }

  ngOnInit(): void {
    this.tenant = this.authService.principal.provider;
    this.loadSolutions();
  }

  selectFilter(filter: string): void {
    if (this.filters.has(filter)) {
      this.filters.delete(filter);
    } else {
      this.filters.add(filter);
    }
    this.applyFilter();
  }

  clearFilter(): void {
    this.filters.clear();
    this.applyFilter();
  }

  /**
   * Loads the solutions and for each solution loads its versions and prepares the Map
   * containing the needed information for the cards
   */
  private loadSolutions(): void {
    this.solutionsService.getMySolutions()
      .pipe(
        mergeMap((solutions: any[]) => forkJoin(
          solutions.map(solution => this.solutionsService.getSolutionVersions(solution.id)
            .pipe(
              map((versions: any) => {
                this.servicesVersionsMap.set(solution.id, versions);
                return solution;
              })
            ))
        )),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(solutions => {
        this.loadServiceCardInformation(solutions);
      });
  }

  /**
   * Loads the information needed for displaying service cards
   */
  private loadServiceCardInformation(services: Solution[]): void {
    this.serviceCardService.getServiceCardInfos(services, this.servicesVersionsMap)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(cardInfos => {
        this.cardInfos = cardInfos.filter(cardInfo => !cardInfo.blueprint.demo || cardInfo.instances.length);
        this.filteredCardInfos = this.cardInfos;
        this.mapStatusToCount(cardInfos);
        this.totalCount = this.cardInfos.length;
      });
  }

  private mapStatusToCount(cardInfos: ServiceCardInfo[]): void {
    cardInfos.forEach(cardInfo => {
      if (!this.statusToCount.has(cardInfo.status)) {
        this.statusToCount.set(cardInfo.status, 0);
      }
      this.statusToCount.set(cardInfo.status, this.statusToCount.get(cardInfo.status) + 1);
    });
  }

  private applyFilter(): void {
    if (this.filters.size === 0) {
      this.filteredCardInfos = this.cardInfos;
    } else {
      this.filteredCardInfos = this.cardInfos.filter(cardInfo => this.filters.has(cardInfo.status));
    }
  }
}
